exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "header[data-v-c755036e]{display:flex}header h2[data-v-c755036e]{flex-grow:1}header button[data-v-c755036e]{width:auto;margin-top:0;padding:.5rem 1rem;border-radius:3px;flex-shrink:1}", ""]);

// exports
